module.exports = __webpack_public_path__ + "media/images/top/common/img_step02-aac8c7218e719703522ff1dfec376c35.png";